import { useFormContext, useFieldArray } from "react-hook-form";

import { FormValues } from "../new-holiday-list-form";
import { DataTable } from "./data-table";
import { columns } from "./columns";

export const HolidayListTable = () => {
  const formContext = useFormContext<FormValues>();

  const {
    append: appendHolidayRow,
    remove: removeHolidayRow,
    fields: holidayRows,
    update: updateHolidayRow,
  } = useFieldArray({
    name: "holidays",
    control: formContext.control,
  });

  return (
    <div className="px-4 mt-5">
      <h3 className="my-3">Holidays</h3>
      <DataTable
        columns={columns}
        data={holidayRows}
        removeHolidayRow={removeHolidayRow}
        appendHolidayRow={appendHolidayRow}
        updateHolidayRow={updateHolidayRow}
      />
    </div>
  );
};
